/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { etoileProgrammes2 } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_multi_015: Question = {
  id: 'multi-015-programmes-restauration-friche',
  oldId: '76',
  title: 'Programmes de conservation et de restauration de friche',
  number: '7.7',
  description: ['Nombre total de projets réalisés de conservation et restauration de friche en milieu urbain'],
  type: QuestionType.INDICATOR,
  frequency: 1,
  slots: [
    {
      type: SlotTypes.ETOILES,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: false,
      optional: true,
      scoringFct: (data:number) => {
        if (data >= 3) return 3;
        if (data >= 2) return 2;
        if (data >= 1) return 1;
        return 0;
      },
      score: '0',
      maxScore: 3,
      help: etoileProgrammes2,
      unit: SlotUnit.NUMBER_OF,
    },
  ],
};

export const question_multi_015_v2: Question = question_multi_015;
export const question_multi_015_v3: Question = question_multi_015;
